import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

// components
import Button3d from '../../../../components/ButtonWrapper/components/Button3d';
import Chat from '../../../../components/Chat';

const CommCenterMyStudio = () => {
    const [tabState, setTabState] = useState('chatClient');

    return (
        <div className="appCommCenter">
            <div className="appWorkbenchPanel commCenterPanel">
                <Button3d
                    changeFn={() => setTabState('chatClient')}
                    name="chatClient"
                    checked={tabState === 'chatClient'}>
                    {__('Client', 'soundbetween')}
                </Button3d>
                <Button3d
                    changeFn={() => setTabState('chat')}
                    name="chat"
                    checked={tabState === 'chat'}>
                    {__('Team', 'soundbetween')}
                </Button3d>
            </div>
            <div className="appDashboard__workbench">
                {tabState === 'chatClient' ? <Chat type="CUSTOMER"/> : <Chat type="TEAM"/>}
            </div>
        </div>
    )
}

export default CommCenterMyStudio;